import React from 'react';
import { withRouter } from "react-router";

import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

// Images
import brandedSurveyLogo from './images/branded-survey-logo.png';
import surveyJunkieLogo from './images/survey-junkie-logo.png';
import surveyTimeLogo from './images/survey-time-logo.png';

class Panel extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.location.state;

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event, v) {
    let userForm = this.state.userForm;
    userForm[v] = event.target.value;
    this.setState({ userForm });
  }

  setSelected(i) {
    let offers = this.state.offers;
    offers[i]["selected"] = !offers[i]["selected"];
    let selectedAll = this.state.selectedAll;
    if (!offers[i]["selected"]) {
      selectedAll = false;
    }
    this.setState({ offers, selectedAll });
  }

  selectAll() {
    let offers = this.state.offers;
    offers.map((v, i) => {
      v.selected = true;
    })
    this.setState({ offers, selectedAll: true });
  }

  handleSubmit() {
    this.props.history.push({
      pathname: '/details',
      state: this.state
    });
  }



  render() {
    return (
      <div className="body">
        <div className="banner-panel banner-small">
          <div className="banner-overlay">
            <div className="gradient"></div>
          </div>
        </div>
        <Container>
          <Row className="text-center pt-5">
            <Col md={12}>
              <p>Select the companies you want to receive surveys from. <strong><em>Limited places available! Hurry!</em></strong></p>
              <h4><strong>SELECT ALL</strong> to earn up to $300* a month!</h4>
            </Col>
          </Row>
          <Row className="text-center mt-5 justify-content-center">
            {this.state.selectedAll ? <button id="select-all" data-action="select-all" type="button" className="btn btn-gold active" onClick={(e) => this.selectAll()}>Selected all</button> : <button id="select-all" data-action="select-all" type="button" className="btn btn-gold"  onClick={(e) => this.selectAll()}>Select all</button>}
          </Row>

          {this.state.offers.map((value, i) => {
            return <Row key={i} className="text-center">
              <Col md={12}>
                <div className="row align-items-center no-gutters" id="panel-detail">
                  <div className="col-md-3 p-5">
                    <img className="mt-4 mt-md-0 img-fluid" src={value.logo} />
                  </div>
                  <div className="col-md-6 text-left border-right border-left">
                    <div className="row no-gutters align-items-center">
                      <div className="col-md-8">
                        <div className="panel-content pt-3">
                          <ul>
                            <li>{value.description1}</li>
                            <li>{value.description2}</li>
                            <li>{value.description3}</li>
                          </ul>
                        </div>
                        <ul className="details">
                          <li data-action="open-terms">Terms &amp; Conditions</li>
                          <li data-action="open-policy">Privacy Policy</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3" style={{ paddingRight: 22, paddingLeft: 22 }} data-children-count="1">
                    <input type="checkbox" name="panels[]" value="328838a0-f587-11e9-b11b-912f02a8455a" />
                    {value.selected ? <button className="select-panel active" type="button" onClick={(e) => this.setSelected(i)} >Selected</button> : <button className="select-panel" type="button" onClick={(e) => this.setSelected(i)} >Select</button>}
                  </div>
                </div>
              </Col>
            </Row>
          })}

          <Row className="justify-content-center">
            <Col md={4}>
              {this.state.selectedAll ? <button type="button" className="btn btn-primary btn-gold btn-block mb-4 active" onClick={(e) => this.selectAll()}>Selected all</button> : <button type="button" className="btn btn-primary btn-gold btn-block mb-4" onClick={(e) => this.selectAll()}>Select all</button>}
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={4}>
              <input id="submit-btn" className="btn btn-primary btn-block disableonclick" onClick={(e) => this.handleSubmit()} type="submit" value="Submit"></input>
            </Col>
          </Row>
          <Row className="pb-5"></Row>
        </Container>
        <div className="footer text-center">
          <div className="container">
            <div className="row">
            </div>
            <div className="row">
              <div className="col-12 copyright">
                <ul>
                  <li><a href="">Terms &amp; Conditions</a></li>
                  <li><a href="">Privacy Policy</a></li>
                </ul>
                <p>© 2021 Kensto</p>
                <p>*Based on <a className="text-underline" href="">possible earnings</a>. These differ due to panelist demographics and survey companies selected, results vary per person.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(Panel);